import { Row, Col } from "react-bootstrap";
import PropTypes from "prop-types";

import { Button } from "components/Button";
import { useNavigation } from "utils/navigate";
import { iconConfirmationV2 } from "assets/icons";
import { Title } from "style/components/Title.styles";
import { CompletionModalContainer } from "./CompletionModal.styles";

export const CompletionModal = ({ show, onHide }) => {
  const { navigateToV2HelpCenter } = useNavigation();

  const handleHelpCenterClick = () => {
    navigateToV2HelpCenter();
    handleHide();
  };

  const handleHide = () => {
    onHide();
  };

  return (
    <CompletionModalContainer show={show} onHide={onHide} centered={false}>
      <div className="d-flex justify-content-center">
        <img src={iconConfirmationV2} className="img" />
      </div>
      <Title>Congratulations</Title>

      <div className="description">
        You completed all tasks in our onboarding checklist.
      </div>

      <Row>
        <Col md={6}>
          <Button
            onClick={handleHide}
            variant="secondary"
            className="button-outlined"
          >
            Close
          </Button>
        </Col>
        <Col md={6}>
          <Button onClick={handleHelpCenterClick}>Help Center</Button>
        </Col>
      </Row>
    </CompletionModalContainer>
  );
};

CompletionModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
};
